// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1cM8q","main-image":"Header_main-image__1RoZ3"};